var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcAccountCircle48Px(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_account_circle_48px",
    clipPath: "url(#clip0_75_2262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28 4.66666C15.1083 4.66666 4.66663 15.1083 4.66663 28C4.66663 40.8917 15.1083 51.3333 28 51.3333C40.8916 51.3333 51.3333 40.8917 51.3333 28C51.3333 15.1083 40.8916 4.66666 28 4.66666ZM28 11.6667C31.8616 11.6667 35 14.805 35 18.6667C35 22.54 31.8616 25.6667 28 25.6667C24.1383 25.6667 21 22.54 21 18.6667C21 14.805 24.1383 11.6667 28 11.6667ZM28 44.8C22.155 44.8 17.0216 41.8133 14 37.2867C14.0583 32.655 23.345 30.1 28 30.1C32.655 30.1 41.93 32.655 42 37.2867C38.9783 41.8133 33.845 44.8 28 44.8Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_2262"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccountCircle48Px);
export default __webpack_public_path__ + "static/media/ic_account_circle_48px.63b1fc2aab006963370eadfc2fd8e470.svg";
export { ForwardRef as ReactComponent };